import { type ElementType } from 'react';
import { InternalOrExternalLink } from '@leagueplatform/web-common-components';
import { type MasonryEngineNodeAction } from '@leagueplatform/masonry-engine';
import { isLinkAction } from './is-link-action';

interface UseMasonryActionSemantics {
  action: MasonryEngineNodeAction | undefined;
}

/**
 * Helper function to get the semantics for links and buttons based on the masonry action.
 *
 * @param {MasonryEngineNodeAction | undefined} action - The action to get the semantics for.
 * @returns {Object} The semantics for the action, including href and as.
 */

export const getMasonryActionComponentSemantics = ({
  action,
}: UseMasonryActionSemantics) => {
  if (!action) {
    return {};
  }

  const isLink = isLinkAction(action);
  let url: string | undefined;
  let as: ElementType = 'button';

  if (isLink) {
    url = action.payload?.url as string;
    as = InternalOrExternalLink;
  }

  return { href: url, as };
};
